import React from "react";
import { Button, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { NavLink } from ".";

const useStyles = makeStyles((theme) => ({
  actionButton: {
    backgroundColor: "#00A5E4",
    color: "#FFFFFF",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    marginLeft: 3,
    marginRight: 10,
    height: 32,
    borderRadius: 10,
    padding: "0 12px",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#0095CE",
    },
    "&:disabled": {
      opacity: 0.6,
      color: "#FFFFFF",
      backgroundColor: "#00A5E4",
    },
  },
}));

const ActionButton = ({
  tooltipTitle = "",
  buttonText = "",
  path = "",
  startIcon = null,
  onClick = null,
  style = {},
  disabled = false,
}) => {
  const classes = useStyles();

  const buttonProps = onClick ? { onClick } : { component: NavLink, path };

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        {" "}
        {/* Wrapper needed to make tooltip work with disabled button */}
        <Button
          className={classes.actionButton}
          variant="contained"
          color="primary"
          startIcon={startIcon}
          disabled={disabled}
          style={{
            ...style,
          }}
          {...buttonProps}
        >
          {buttonText}
        </Button>
      </span>
    </Tooltip>
  );
};

export default React.memo(ActionButton);
